import Axios_lib from 'axios';
import {
  AMLS_COMMON,
  AMLS_COMMON_HTTP_HEADERS,
  AMLS_TM_COMMON
} from '../pages/constants/globalConstants';
import {
  getDataFromServer,
  putDataToServer,
  postDataToServerWithFullResponse
} from './util';
import { createAxiosServiceInstance } from './api';

const axios = createAxiosServiceInstance();

export const fetchCategoriesAPI = async () => {
  const url = `${AMLS_TM_COMMON}/segmentCategories`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS);
};

export const postSegmentSetsAPI = async (payload) => {
  const url = `${AMLS_TM_COMMON}/segmentSets`;
  const response = await postDataToServerWithFullResponse(url, payload);

  if (response.status !== 200 && response.status !== 201) {
    throw new Error(
      response?.data?.message || 'Failed to save the configuration'
    );
  } else {
    return response.data;
  }
};

export const fetchLiveSetsAPI = async () => {
  const url = `${AMLS_TM_COMMON}/segmentSets`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS);
};

export const widgetColumnItemsAPI = async (payload) => {
  const { pageId } = payload;
  let params = {
    pageId
  };
  const url = `${AMLS_COMMON}/uiconfig/item-operations`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS, params);
};

export const alertListingColumnNamesAPI = async () => {
  const url = `${AMLS_COMMON}/alerts/alertColumns`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS);
};

export const alertDetailsColumnNamesAPI = async (payload) => {
  const { widgetUrl } = payload;
  const url = `${AMLS_COMMON}/uiconfig/${widgetUrl}`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS);
};

export const tmAlertListingSettingsAPI = async (payload) => {
  const { widgetId } = payload;
  let params = {
    widgetId
  };
  const url = `${AMLS_COMMON}/uiconfig`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS, params);
};

export const putTmAlertListingSettingsAPI = async (payload) => {
  const { data } = payload;
  const url = `${AMLS_COMMON}/uiconfig`;
  return await putDataToServer(url, AMLS_COMMON_HTTP_HEADERS, {}, data);
};

export const globalSettingsPageInfoAPI = async (payload) => {
  const params = payload;
  const url = `${AMLS_COMMON}/uiconfig/pageInfo`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS, params);
};

export const putGlobalSettingsWidgetGroupAPI = async (payload) => {
  const { data, params } = payload;
  const url = `${AMLS_COMMON}/uiconfig/widgetGroup`;
  return await putDataToServer(url, AMLS_COMMON_HTTP_HEADERS, { params }, data);
};

export const putGlobalSettingsWidgetsAPI = async (payload) => {
  const { data, params } = payload;
  const url = `${AMLS_COMMON}/uiconfig/widgets`;
  return await putDataToServer(url, AMLS_COMMON_HTTP_HEADERS, { params }, data);
};

export const putGlobalSettingsWidgetInfoAPI = async (payload) => {
  const { data } = payload;
  const url = `${AMLS_COMMON}/uiconfig/widgetInfo`;
  return await putDataToServer(url, AMLS_COMMON_HTTP_HEADERS, {}, data);
};

let source;
export const nsMatchingConfigListingSettingsAPI = async (payload) => {
  if (source) {
    source.cancel();
  }
  const CancelToken = Axios_lib.CancelToken;
  source = CancelToken.source();
  const params = payload;
  const url = `${AMLS_COMMON}/uiconfig/pageInfo`;

  return axios.get(url, { cancelToken: source.token, params }).then((res) => {
    if (res.status !== 200) {
      throw new Error(res?.data?.message ?? 'Failed to get config settings');
    }
    return res.data;
  });
};

export const amlsCommonGlobalSettingsAPI = async (payload) => {
  const params = payload;
  const url = `${AMLS_COMMON}/uiconfig/pageInfo`;
  return await getDataFromServer(url, AMLS_COMMON_HTTP_HEADERS, params);
};
